<template>
	<div v-if="featuredUpdates.length" class="flex flex-col gap-1">
		<div
			class="rounded p-2"
			:class="`asitmiup-color--${update.color}`"
			v-for="update of featuredUpdates"
			:key="update.id"
		>
			<div class="flex flex-row gap-1 text-left">
				<n-icon class="opacity-50" :size="variant !== 'ultra-compact' ? 20 : 14">
					<i-carbon-information-filled />
				</n-icon>
				<n-ellipsis
					expand-trigger="click"
					:line-clamp="
						['full', 'article-box'].includes(variant)
							? 7
							: variant === 'compact'
							? Math.max(businessHoursServicesCount || 0, 2)
							: 1
					"
					class="text-xs leading-tight font-medium flex-1"
				>
					<template #tooltip>
						{{
							stringaMultilingua(
								'Clicca per leggere tutto',
								'Click to read everything',
								'Klicken Sie hier, um alles zu lesen'
							)
						}}
					</template>
					<span
						class="align-middle"
						v-html="formatContent(update.translations?.[0]?.content)"
					></span>
				</n-ellipsis>
			</div>
		</div>
		<div
			v-if="updates.length > featuredUpdates.length && variant !== 'ultra-compact'"
			class="text-right"
		>
			<n-button
				type="primary"
				size="tiny"
				icon-placement="right"
				text
				class="text-xs"
				:theme-overrides="{
					heightTiny: '',
					paddingTiny: '',
					iconMarginTiny: '0 0 0 1px',
					iconSizeTiny: '12px',
				}"
				@click="showModal = true"
			>
				<template #icon>
					<n-icon>
						<i-carbon-chevron-right />
					</n-icon>
				</template>
				{{ stringaMultilingua('Aggiornamenti', 'Updates', 'Updates') }}
			</n-button>
		</div>
		<n-modal
			v-model:show="showModal"
			preset="card"
			class="max-w-[500px]"
			:title="
				stringaMultilingua('Note e aggiornamenti', 'Notes and updates', 'Hinweise und Updates')
			"
		>
			<div class="flex flex-col gap-2">
				<div
					class="rounded p-2"
					:class="`asitmiup-color--${update.color}`"
					v-for="update of updates"
					:key="update.id"
				>
					<div class="flex flex-row gap-1">
						<n-icon class="opacity-50" size="20"><i-carbon-information-filled /></n-icon>
						<div
							class="text-xs leading-tight font-medium"
							v-html="formatContent(update.translations?.[0]?.content)"
						></div>
					</div>
				</div>
			</div>
		</n-modal>
	</div>
</template>

<script setup>
	import {toRefs, computed, ref} from 'vue'
	import {NIcon, NButton, NModal, NEllipsis} from 'naive-ui'
	import ICarbonChevronRight from '~icons/carbon/chevron-right'
	import ICarbonInformationFilled from '~icons/carbon/information-filled'

	const props = defineProps({
		data: Object,
		variant: {
			type: String,
			default: 'full',
		},
		locale: {
			type: String,
			default: 'it',
		},
		businessHoursServicesCount: {
			type: Number,
		},
	})
	const {data, variant, locale, businessHoursServicesCount} = toRefs(props)
	const language = computed(() => locale.value.split('-')[0])
	const showModal = ref(false)
	const updates = computed(() => data.value.filter(update => update.translations?.[0]?.content))

	const featuredUpdates = computed(() => {
		switch (variant.value) {
			case 'full':
			case 'article-box': {
				// number could be higher if there are more pinned updates
				const MAX_FEATURED = 1
				return updates.value
					.slice(0, MAX_FEATURED)
					.concat(updates.value.slice(MAX_FEATURED).filter(o => o.pinned))
			}
			case 'ultra-compact': {
				if (!businessHoursServicesCount.value) {
					return [updates.value[0]].filter(Boolean)
				}
				return []
			}
			default:
				return [updates.value[0]].filter(Boolean)
		}
	})

	function stringaMultilingua(...params) {
		switch (language.value) {
			case 'it':
				return params[0]
			case 'de':
				return params[2]
			default:
				// 2
				return params[1]
		}
	}

	function formatContent(content) {
		return content?.replace(/\r\n|\r|\n/g, '<br />')
	}
</script>
